import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api/projects`);

export const getWorkflowStatuses = async (projectId) => {
  const response = await API.get(`/${projectId}/workflow-statuses/`);
  return response.data;
};

export const createWorkflowStatus = async (projectId, data) => {
  const response = await API.post(`/${projectId}/workflow-statuses/`, data);
  return response.data;
};

export const updateWorkflowStatus = async (projectId, statusId, data) => {
  const response = await API.put(`/${projectId}/workflow-statuses/${statusId}`, data);
  return response.data;
};

export const reorderWorkflowStatuses = async (projectId, statusIds) => {
  const response = await API.patch(`/${projectId}/workflow-statuses/reorder`, { status_ids: statusIds });
  return response.data;
};

export const deleteWorkflowStatus = async (projectId, statusId, reassignToStatusId) => {
  const response = await API.delete(`/${projectId}/workflow-statuses/${statusId}`, {
    params: reassignToStatusId ? { reassign_to_status_id: reassignToStatusId } : {}
  });
  return response.data;
};
